import { apiFormData } from '../configs/axiosConfigs';

export const createPropertyComments = async(property_id: string, requestBody, config: any = {}) => {
  return await apiFormData.post(`/properties/${property_id}/comments`, requestBody, config);
};
